import api from '../../../services/api'
import { BaseRepository } from './base.repository'
import { Course } from '@/domain/entities/course.entity'

export class CursoRepository extends BaseRepository {
  private static Instance: CursoRepository = null
  public static GetInstance() {
    return (this.Instance = this.Instance || new CursoRepository())
  }

  async listInstitutionsWithParameters(
    category_id: number,
    cidade: string,
    bairro: string,
  ) {
    const headers = { Authorization: `Bearer ${this.token}` }
    const response = await api.get('/institutions', {
      headers,
      params: {
        category_id,
        cidade,
        bairro,
        status: 'active',
      },
    })
    return response.data as any[]
  }

  async listCourses(
    token: string,
    category_id: number,
    city?: string,
    course?: string,
    neighborhood?: string,
  ) {
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }

    const response = await api.get('/curso', {
      headers,
      params: {
        category_id,
        city,
        course,
        neighborhood,
      },
    })

    return response.data as { courses: Course[] }
  }

  async listInstitutionCursesByCategory(
    institution_id: string,
    category_id: string,
  ) {
    const response = await api.get(
      '/institutions/courses/' + institution_id + '/' + category_id,
    )
    return response.data as { courses: Course[] }
  }

  async listarCursosDaCategoria(category_id: string) {
    const response = await api.get('/curso/categoria/' + category_id)
    return response.data.cursos as Course[]
  }
}
